module.exports = __webpack_public_path__ + "img/easter_egg_modal_next.6d8a7b6f.png";